import { useQuery } from '@tanstack/react-query';
import { apiClient, unwrap } from '@/lib/api-client';

export const dashboardKeys = {
  all: ['dashboard'] as const,
};

async function fetchDashboard() {
  const res = await apiClient.dashboard.get();
  return unwrap(res.data);
}

export type DashboardData = Awaited<ReturnType<typeof fetchDashboard>>;

export function useDashboard() {
  return useQuery({
    queryKey: dashboardKeys.all,
    queryFn: fetchDashboard,
  });
}
